import { loginUser, logoutUser, refreshToken } from "../clients/AuthApiClient";

const ACCESS_TOKEN = process.env.REACT_APP_ACCESS_TOKEN_KEY;

export async function processLogin(username, password) {
    try {
        const response = await loginUser(username, password);
        const data = response?.data || {};
        // бэк может вернуть 200 с {is_ok:false, message:...} либо без токена
        if (data.is_ok === false || !data.access_token) {
            throw new Error(data.message || "Неверный логин или пароль");
        }
        localStorage.setItem(ACCESS_TOKEN, data.access_token);
        return true;
    } catch (e) {
        console.error("Ошибка авторизации:", e);
        // достаём сообщение бэка из тела ответа (4xx) или из брошенной ошибки
        const message = e.response?.data?.message || e.message || "Неверный логин или пароль";
        throw new Error(message);
    }
}

export async function processLogout() {
    localStorage.removeItem(ACCESS_TOKEN);
    await logoutUser();
}

export async function processRefreshToken() {
    try {
        const response = await refreshToken(); // backend достанет refresh из cookie
        const accessToken = response.data.access_token;
        if (!accessToken) {
            throw new Error("Нет нового access токена");
        }
        localStorage.setItem(ACCESS_TOKEN, accessToken);
        return accessToken;
    } catch (e) {
        await processLogout();
        throw e;
    }
}


export async function getAccessToken() {
    let token = localStorage.getItem(ACCESS_TOKEN);
    if (!token) {
        token = await processRefreshToken();
    }
    return token;
}
